import {Component, Vue} from "vue-property-decorator";
import QuotaLine from "@/components/QuotaLine.vue";
import HeaderContainer from "@/components/HeaderContainer.vue";
import ReservationCard from "@/components/ReservationCard.vue";
import BubbleAction from "@/components/BubbleAction.vue";
import Toaster from "@/components/Toaster.vue";
import RoomNotif from "@/components/RoomNotif.vue";
import RoomNotifConfig from "@/types/RoomNotifConfig";
import {CardConfig, CardStatus, ReservationCardConfig, SeparatorConfig} from "@/types/ReservationCardConfig";
import Reservations from "@/components/Reservations.vue";
import SeparationTitle from "@/components/SeparationTitle.vue";
import ReservationsConfig from "@/types/ReservationsConfig";
import api from "@/services/apiService";
import moment, {Moment} from "moment"
import 'moment/locale/fr';
import {ReservationAPIInterface,} from "@/entity/Reservation";
import {QuotaLineConfig} from "@/types/QuotaLineConfig";
import {UserAPIInterface} from "@/entity/User";
import {ToasterType} from "@/types/ToasterConfig";
import {ErrorService} from "@/services/ErrorService";
import {mapGetters} from "vuex";
import Wrapper from "@/components/Wrapper.vue";



enum RoomNotifState {
  InOneHour = 1,
  Soon = 2,
  OnGoing = 3,
  Ended = 4,
  Empty = 5
}

export interface CustomWindow extends Window {
  intervals: Array<number|null>;
}

declare let window: CustomWindow;

@Component({
  components: {
    HeaderContainer,
    QuotaLine,
    ReservationCard,
    BubbleAction,
    Toaster,
    RoomNotif,
    Reservations,
    SeparationTitle,
    Wrapper
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getVersionInformations',
      'isAdmin',
    ]),
  },
})
export default class Home extends Vue {

  public roomNotification: RoomNotifConfig = {
    class: '',
    illustration: "",
    title: '',
    message: '',
    timer: '',
    button: false,
  };

  public quotaLineConfig: QuotaLineConfig = {
    mode: 'full',
    weekNumber: moment().format('WW'),
    year: moment().format('YYYY'),
  };
  public isLoadingTitle: SeparatorConfig = {
    text: "Chargement en cours ...",
    isMonthDisplayed: true,
  };

  // Tout est dans un enorme tableau
  public cardsConfigurations: ReservationCardConfig[] = [];
  public nextReservation: ReservationAPIInterface[] = [];
  public moisAffiche = "";
  public jourAffiche = "";
  public monthDisplayed = {
    isMonthDisplayed: false,
    yearMonthDisplayed: ""
  };
  public dayDisplayed = {
    isDayDisplayed: false as boolean,
    monthDayDisplayed: "",
    yearDayDisplayed: ""
  };
  public isLoadingReservations: boolean = true;
  public loadingCardConfig: CardConfig = {
    path: '',
    class: CardStatus.Loading,
    day: {
      withDay: true,
      number: '',
      text: '',
      isCurrentDay: true,
    },
    name: '',
    hours: {
      start: '',
      end: '',
    },
    owner: '',
  };
  public reservationsConfig: ReservationsConfig = {
    number: 0
  };
  public ongoingReservation: ReservationAPIInterface[] = [];

  async mounted() {
    moment.locale('fr');
    this.$store.dispatch('updateQuotaLine', this.quotaLineConfig);
    await this.loadCurrentReservation();
    await this.loadReservations();
    this.removeIntervals();
    this.setAutoUpdate();
    this.checkNextReservation();
  }

  async beforeDestroy() {
    this.removeIntervals();
    this.$store.commit('unsetQuotaInformations');
  }

  public removeIntervals() {
    if (window.intervals) {
      for (const interval of window.intervals) {
        if(interval === null) continue;
        window.intervals[window.intervals.indexOf(interval)] = null;
        window.clearInterval(interval);
      }
    } else {
      window.intervals = [];
    }
  }

  public clearNullIntervals() {
    if (window.intervals) {
      window.intervals = window.intervals.filter(function (el) {
        return el != null;
      });
    }
  }

  public async openCloseAdmin(value: string) {
    if (value === 'open') {
        await api.authRequest.get('/nuki/open-admin')
          .then((response) => {
            this.$store.commit('updateToaster', {
              type: ToasterType.Green,
              message: 'Ouverture de la porte, merci de patientez quelques secondes.',
            });
          }).catch((error) => {
            ErrorService.dealWithTheError(error);
          }).finally(() => {
          });
    } else {
      await api.authRequest.get('/nuki/close-admin')
        .then((response) => {
          this.$store.commit('updateToaster', {
            type: ToasterType.Green,
            message: 'Fermeture de la porte, merci de patientez quelques secondes.',
          });
        }).catch((error) => {
          ErrorService.dealWithTheError(error);
        }).finally(() => {
        });
    }
  }

  public formattedCountdown(isUntilEnd: boolean = false, isUntilOpen: boolean = false): string {
    const countdown = this.countdown(isUntilEnd);
    let countdownFormatted: string = "";

    if (countdown !== undefined) {
      if (isUntilOpen) {
        countdown.subtract(5, "minutes")
      }

      if (countdown.hours() !== 0) {
        countdownFormatted = countdown.hours() + "h ";
      }
      if (countdown.minutes() !== 0) {
        countdownFormatted += countdown.minutes() + "m ";
      }
      if (countdown.seconds() !== 0) {
        countdownFormatted += countdown.seconds() + "s ";
      }
      return countdownFormatted;
    }
    return "error";
  }

  public async checkNextReservation() {

    if (this.nextReservation.length > 0 || this.ongoingReservation.length > 0) {
      const startDate = this.checkStartDate();
      this.checkOngoing();
      if (this.ongoingReservation.length === 0) {
        if (moment(startDate).isBetween(moment(), moment().add(5, "minutes"))) {
          this.roomNotification = this.checkRoomNotifState(RoomNotifState.Soon);
        } else if (moment(startDate).isBetween(moment().subtract(5, "minutes").format(), moment().add(1, "hours").format())) {
          this.roomNotification = this.checkRoomNotifState(RoomNotifState.InOneHour);
        } else {
          this.roomNotification = this.checkRoomNotifState(RoomNotifState.Empty);
        }
      }
    }
  }

  public checkStartDate(): string {
    if (this.nextReservation.length > 0) {
      return this.nextReservation[0].startDate;
    } else {
      return '';
    }
  }

  public async checkOngoing() {
    let countdownUntilEnd = this.countdown(true);

    if (this.ongoingReservation.length === 0 && (moment(this.nextReservation[0].startDate).isBefore(moment()) && moment(this.nextReservation[0].endDate).isAfter(moment()))) {
      this.ongoingReservation.push(this.nextReservation[0]);
    } else if (this.ongoingReservation.length === 1) {
      if (countdownUntilEnd !== undefined && countdownUntilEnd.asSeconds() <= 0)
        this.ongoingReservation = [];
    }

    if (this.ongoingReservation.length > 0) {
      countdownUntilEnd = this.countdown(true);
      if (countdownUntilEnd !== undefined && countdownUntilEnd.minutes() > 4) {
        this.roomNotification = this.checkRoomNotifState(RoomNotifState.OnGoing);
      } else {
        this.roomNotification = this.checkRoomNotifState(RoomNotifState.Ended);
      }
    }
  }

  public setAutoUpdate() {
    this.clearNullIntervals();
    window.intervals.push(setInterval(async () => {
      await this.loadCurrentReservation();
      await this.loadReservations();
    }, 2 * 60 * 1000));
    window.intervals.push(setInterval(() => this.checkNextReservation(), 1000));
  }

  public countdown(isEndTime: boolean = false) {
    if (this.nextReservation.length > 0) {
      let eventStartTime = moment(this.nextReservation[0].startDate);
      let currentTime = moment();
      if (isEndTime) {
        if (this.ongoingReservation.length !== 0) {
          this.ongoingReservation[0].startDate = this.formatTime(this.ongoingReservation[0].startDate);
          return moment.duration(moment(this.formatTime(this.ongoingReservation[0].endDate)).diff(currentTime));
        }
      } else {
        return moment.duration(eventStartTime.diff(currentTime));
      }
    } else {
      if (isEndTime) {
        let currentTime = moment();
        if (this.ongoingReservation.length !== 0) {
          this.ongoingReservation[0].startDate = this.formatTime(this.ongoingReservation[0].startDate);
          return moment.duration(moment(this.formatTime(this.ongoingReservation[0].endDate)).diff(currentTime));
        }
      }
    }
  }

  public checkRoomNotifState(status: RoomNotifState) {

    switch (status) {
      case RoomNotifState.InOneHour:
        return {
          class: 'RoomNotifEnd',
          illustration: require('@/assets/illustrations/desktop.svg'),
          title: "Votre réunion : " + this.nextReservation[0].name + ", débute bientôt.",
          message: "Vous pourrez dévérouiller la salle dans : ",
          timer: this.formattedCountdown(false, true),
          button: false,
        };
      case RoomNotifState.Soon:
        return {
          class: 'RoomNotifUnlock',
          illustration: require('@/assets/illustrations/unlock.svg'),
          title: "Plus que quelques instants avant votre réunion " + this.nextReservation[0].name + ".",
          message: "Votre réunion débute dans :",
          timer: this.formattedCountdown(),
          button: true,
        };
      case RoomNotifState.OnGoing:
        return {
          class: 'RoomNotifWork',
          illustration: require('@/assets/illustrations/work.svg'),
          title: 'Votre réunion : ' + this.ongoingReservation[0].name + ' est en cours',
          message: 'Elle se terminera dans : ',
          timer: this.formattedCountdown(true),
          button: true,
        };
      case RoomNotifState.Ended:
        return {
          class: 'RoomNotifEnd',
          illustration: require('@/assets/illustrations/desktop.svg'),
          title: 'Votre réservation se termine bientôt !',
          message: 'Pensez à laisser la salle propre, votre réunion se termine dans :',
          timer: this.formattedCountdown(true),
          button: true,
        };
      case RoomNotifState.Empty:
        return {
          class: '',
          illustration: '',
          title: '',
          message: '',
          timer: '',
          button: false,
        };
    }
  }

  public isDayToDisplay(startDate: Moment): boolean {
    if (!this.dayDisplayed.isDayDisplayed ||
      this.jourAffiche !== startDate.format('D') ||
      (this.dayDisplayed.isDayDisplayed && startDate.format("MMMM") !== this.dayDisplayed.monthDayDisplayed) ||
      (this.dayDisplayed.isDayDisplayed && startDate.format("YYYY") !== this.dayDisplayed.yearDayDisplayed)) {
      this.dayDisplayed.isDayDisplayed = true;
      this.dayDisplayed.monthDayDisplayed = startDate.format('MMMM');
      this.dayDisplayed.yearDayDisplayed = startDate.format('YYYY');
      this.jourAffiche = startDate.format('D')
      return true;
    } else {
      return false;
    }
  }

  public isMonthToDisplay(startDate: Moment): boolean {
    if (startDate.isAfter(moment())) {
      if (!this.monthDisplayed.isMonthDisplayed) {
        this.monthDisplayed.isMonthDisplayed = true;
        this.moisAffiche = startDate.format('MMMM YYYY');
        return true;
      } else {
        if (this.moisAffiche !== startDate.format('MMMM YYYY')) {
          this.monthDisplayed.isMonthDisplayed = true;
          this.moisAffiche = startDate.format('MMMM YYYY');
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  public resetDisplay() {
    this.jourAffiche = "";
    this.moisAffiche = "";
    this.dayDisplayed.isDayDisplayed = false;
    this.monthDisplayed.isMonthDisplayed = false;
  }

  public formatReservations(reservation: ReservationAPIInterface): ReservationCardConfig {
    const startDateString = reservation.startDate.slice(0, 19);
    const startDate = moment(startDateString);
    const endDateString = reservation.endDate.slice(0, 19);
    const endDate = moment(endDateString);
    let isToday = startDate.format('l') === moment().format('l');

    // @ts-ignore
    const owner: UserAPIInterface = reservation.owner;

    const classType = (owner.email === this.$store.state.authModule.user.email) ? CardStatus.Normal : CardStatus.Disabled;
    const path = (classType === CardStatus.Normal) ? '/reservation/view/' + reservation.id : '';
    const ownerText = (classType === CardStatus.Disabled) ? owner.email : 'moi';

    return {
      card: {
        path: path,
        class: classType,
        day: {
          withDay: this.isDayToDisplay(startDate),
          number: startDate.format('D'),
          text: startDate.format('ddd'),
          isCurrentDay: isToday,
        },
        name: reservation.name,
        hours: {
          start: startDate.format('LT'),
          end: endDate.format('LT'),
        },
        owner: ownerText,
      },
      title: {
        text: moment(reservation.startDate).format('MMMM YYYY'),
        isMonthDisplayed: this.isMonthToDisplay(startDate),
      }
    };
  }

  public formatTime(date: string) {
    return date.slice(0, 19);
  }

  async loadCurrentReservation() {
    try {
      const endpoint = 'reservations?status[]=1&owner=' + this.$store.state.authModule.user.id + '&startDate[before]=' + moment().format("MM/DD/YYYY HH:mm:ss") + "&endDate[after]=" + moment().format("MM/DD/YYYY HH:mm") + '&order[startDate]=asc';
      const response: ReservationAPIInterface = await api.authRequest.get(endpoint);
      this.ongoingReservation = response['hydra:member'];
    } catch (error) {
      ErrorService.dealWithTheError(error);
    }
  }

  async loadReservations() {
    this.resetDisplay();

    try {
      const endpoint = 'reservations?status[]=1&owner=' + this.$store.state.authModule.user.id + '&startDate[after]=' + moment().format("MM/DD/YYYY HH:mm:ss") + '&order[startDate]=asc&itemsPerPage=5';
      const response: ReservationAPIInterface = await api.authRequest.get(endpoint);
      const reservationList: ReservationAPIInterface[] = response['hydra:member'];
      if (reservationList.length > 0) {
        this.reservationsConfig.number = response["hydra:totalItems"];
        this.nextReservation = reservationList.slice(0, 1);
        this.nextReservation[0].startDate = this.formatTime(this.nextReservation[0].startDate);

        const tempCardsConfiguration: ReservationCardConfig[] = [];
        for (let reservation of reservationList) {
          tempCardsConfiguration.push(this.formatReservations(reservation));
        }
        this.cardsConfigurations = tempCardsConfiguration;
      }
    } catch (error) {
      ErrorService.dealWithTheError(error);
    }

    this.isLoadingReservations = false;
  }
}
